<template>
  <div class="gs-seg-filter">
    <div
      class="gs-seg-bar"
      :style="{ '--seg-count': options.length || 1, '--seg-index': activeIndex }"
    >
      <span class="gs-seg-thumb" aria-hidden="true"></span>
      <button
        v-for="item in options"
        :key="String(item.value)"
        type="button"
        class="gs-seg-item"
        :class="{ 'is-active': isActive(item.value) }"
        @click="select(item.value)"
      >
        {{ item.label }}
      </button>
    </div>
    <GsMore
      v-if="moreText"
      class="gs-seg-more"
      @click="$emit('more')"
    >{{ moreText }}</GsMore>
  </div>
</template>

<script>
export default {
  name: 'PillFilter',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    },
    moreText: {
      type: String,
      default: ''
    }
  },
  computed: {
    current() {
      return this.modelValue !== undefined ? this.modelValue : this.value
    },
    activeIndex() {
      const i = this.options.findIndex((item) => String(item.value) === String(this.current))
      return i < 0 ? 0 : i
    }
  },
  methods: {
    isActive(val) {
      return String(this.current) === String(val)
    },
    select(val) {
      if (this.isActive(val)) return
      this.$emit('input', val)
      this.$emit('update:modelValue', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped>
.gs-seg-filter {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  justify-content: flex-end;
  gap: 20px;
}
.gs-seg-bar {
  --seg-pad: 3px;
  position: relative;
  display: flex;
  align-items: stretch;
  flex: 0 0 500px;
  width: 500px;
  max-width: 500px;
  height: 34px;
  padding: var(--seg-pad);
  background: #e8eef6;
  border-radius: 8px;
  box-sizing: border-box;
}
.gs-seg-thumb {
  position: absolute;
  top: var(--seg-pad);
  bottom: var(--seg-pad);
  left: var(--seg-pad);
  width: calc((100% - var(--seg-pad) * 2) / var(--seg-count));
  border-radius: 6px;
  background: #0165FF;
  box-shadow: 0 4px 10px rgba(1, 101, 255, 0.28);
  transform: translateX(calc(var(--seg-index) * 100%));
  transition: transform 0.2s ease;
  pointer-events: none;
  z-index: 0;
}
.gs-seg-item {
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  z-index: 1;
  flex: 1 1 0;
  min-width: 0;
  height: auto;
  border: 0;
  margin: 0;
  outline: none;
  background: transparent !important;
  box-shadow: none !important;
  color: #5b6472;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  padding: 0;
  border-radius: 0;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
}
.gs-seg-item.is-active {
  color: #fff;
  font-weight: 500;
}
.gs-seg-more {
  flex-shrink: 0;
  margin-left: auto;
}
@media (max-width: 960px) {
  .gs-seg-filter {
    justify-content: stretch;
    gap: 10px;
  }
  .gs-seg-bar {
    flex: 1 1 auto;
    width: 100%;
    max-width: none;
    height: 34px;
  }
  .gs-seg-item {
    font-size: 12px;
    line-height: 28px;
  }
}
</style>
